<template>
    <div class="libre-cell" :class="{ 'can-drop': canDrop }">
        <span class="libre-text">{{ dragging ? $t('routines.create_new') : $t('common.free') }}</span>
        <button-tooltip @click="$emit('click:add_block')" text height="24" width="24"
            :tooltip="$t('tooltips.add_block')" :disabled="dragging">
            <v-icon size="15" color="txtMuted">mdi-code-brackets</v-icon>
        </button-tooltip>
    </div>
</template>

<script>
import ButtonTooltip from '../common/ButtonTooltip.vue'
export default {
    components: { ButtonTooltip },
    name: "NoRoutinesInDate",
    props: {
        dragging: {
            type: Boolean,
            default: false,
        },
        canDrop: {
            type: Boolean,
            default: false,
        }
    }
}
</script>

<style scoped>
.libre-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1 1 auto;
    min-height: 60px;
    gap: 2px;
    border-radius: 6px;
}

.libre-text {
    font-size: 12px;
    font-weight: 400;
    color: var(--v-txtMuted-base);
}

.libre-cell.can-drop:hover {
    background-color: rgba(102, 204, 204, 0.06);
    box-shadow: inset 0 0 0 1.5px var(--v-accent-base);
}
</style>
